import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgQuestionMarkCircle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M12 2c-3.17 0-5.715.793-7.461 2.539S2 8.829 2 12c0 3.17.793 5.715 2.539 7.461S8.829 22 12 22c3.17 0 5.715-.793 7.461-2.539S22 15.171 22 12c0-3.17-.793-5.715-2.539-7.461S15.171 2 12 2m0 3.5c-.983-.004-1.961.275-2.717.864A3.27 3.27 0 0 0 8 9c0 .511.106.99.308 1.423a1 1 0 1 0 1.812-.846A1.35 1.35 0 0 1 10 9c0-.466.192-.808.513-1.058.342-.267.862-.445 1.482-.442h.01c.62-.003 1.14.175 1.482.441.321.25.513.593.513 1.059 0 .565-.135.848-.271 1.032-.169.227-.4.394-.805.68l-.008.005c-.366.258-.878.62-1.27 1.189-.415.601-.646 1.351-.646 2.327a1 1 0 1 0 2 0c0-.64.144-.978.292-1.192.168-.243.401-.424.784-.695l.067-.047c.342-.24.821-.576 1.191-1.074C15.76 10.652 16 9.935 16 9c0-1.118-.505-2.03-1.283-2.636-.756-.589-1.733-.868-2.717-.864m0 11a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgQuestionMarkCircle)
export default ForwardRef
